// Copyright (c) 2020 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import InstructionsList from '../../../part-requests/request-details/components/instructions-panels/instructions-list';
import OtherInstruction from '@deere/cps-it.warranty-model-factory/lib/other-instruction';

const NotesPanel = props => {

    const title = (
        <span>
            <FormattedMessage id='MACHINE_INFORMATION'/>
        </span>
    );

    const body = (
        <div className='external-notes'>
            <InstructionsList instructions={props.notes}/>
        </div>
    );

    return (
        <Accordion
            accordionId='external-notes-accordion'
            body={body}
            isExpanded={props.isExpanded}
            title={title}
        />
    );

};

NotesPanel.displayName = 'NotesPanel';
NotesPanel.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    notes: PropTypes.arrayOf(PropTypes.instanceOf(OtherInstruction)).isRequired
};

export default NotesPanel;



// WEBPACK FOOTER //
// ./src/shared/components/notes-panel/index.js